<div>
    <img [src]="'data:image/png;base64,'+payload.guideLineImage" alt="navican-logo">
</div>
<div class="read-more">
    <a [href]="payload.guideLineExternalLink | safe:'url'" target="_blank" >{{payload.guidelineLinkTitle}}</a>
</div>
